import clonedeep from 'lodash.clonedeep';
import { getActiveFiltersWithValues } from './active-filters';
import * as FilterTypeConstants from '../constants/filter-types';
import passesMultiCheckboxFilter from './filters/multi-checkbox';
import passesSingleCheckboxFilter from './filters/single-checkbox';
import passesKeywordsFilter from './filters/keywords';

/**
 * Return a filtered set of items based on a filter object and object keys
 *
 * @param {Array} filters - The array of filter objects to filter the items array by
 * @param {Array} items - The items to filter
 * @returns {Array} Returns - A filtered set of data
 */
export function filterItems(filters, items, keywordSearchableFields) {
    // Make a clone of the items so filtering doesn't affect the main set
    let filteredItems = clonedeep(items);

    // Only keep th items that matches the filter and keyword search
    filteredItems = filteredItems.filter(item => {
        // If no filters supplied, then the item passes without question
        if (!filters || !filters.length) { return true; }

        // find filters that have values. I.e. activeFilters.
        const activeFilters = getActiveFiltersWithValues(filters);

        // loop through every activeFilter
        let filterPass = true;
        activeFilters.forEach(filter => {
            // Handles different types of filters differently
            switch (filter.type) {
                case FilterTypeConstants.FILTER_TYPE_KEYWORDS:
                    if (!passesKeywordsFilter(item, filter, keywordSearchableFields)) {
                        filterPass = false;
                    }
                    break;

                case FilterTypeConstants.FILTER_TYPE_MULTI_CHECKBOX:
                    if (!passesMultiCheckboxFilter(item, filter)) {
                        filterPass = false;
                    }
                    break;

                case FilterTypeConstants.FILTER_TYPE_SINGLE_CHECKBOX:
                    if (!passesSingleCheckboxFilter(item, filter)) {
                        filterPass = false;
                    }
                    break;

                case FilterTypeConstants.FILTER_TYPE_TAGS:
                    if (!passesMultiCheckboxFilter(item, filter)) {
                        filterPass = false;
                    }
                    break;

                default:
                    // No filter type found, make the filter fail
                    filterPass = false;
            }
        });

        // Return filter pass result
        return filterPass;
    });

    return filteredItems;
}

/**
 * Sort the items passed in based on the sort object
 *
 * @param {Array} items - The items to sort - it has to be an array of objects
 * @param {object} currentSort - The sort to apply, it has to be an object with 'field' and 'ascending' attribute
 * @returns {Array} Returns - A sorted set of data
 */
export function sortItems(items, currentSort) {
    // If sort is not specified, return items as they are
    if (!currentSort) { return items; }

    // Sort the items based on the current sort target field and direction
    return items.sort((a, b) => {
        if (a[currentSort.field] < b[currentSort.field]) {
            return (currentSort.ascending ? -1 : 1);
        }

        if (a[currentSort.field] > b[currentSort.field]) {
            return (currentSort.ascending ? 1 : -1);
        }

        return 0;
    });
}

export function paginateItems(items, currentPage, perPage) {
    const startAt = perPage * currentPage;
    const paged = items.filter((item, index) => index >= startAt && index < startAt + perPage);
    return paged;
}



// WEBPACK FOOTER //
// ./src/components/filtered-listing/utils/item-filter.js